import React                from "react";
export const DetailFormContext = React.createContext({});
export const useDetailFormContext = () => React.useContext(DetailFormContext);
